/** One card of the mocked supplies surface. Its own file, as the
 *  one-component-per-file rule has it. */
import { SCOPES } from './supplies-mock';

export function ScopeToggle() {
  return (
    <div
      style={{
        display: 'flex',
        background: 'var(--nb-surface)',
        border: '1px solid var(--nb-border)',
        borderRadius: 999,
        padding: 2,
      }}
    >
      {SCOPES.map((s, i) => (
        <span
          key={s}
          style={{
            height: 22,
            display: 'flex',
            alignItems: 'center',
            padding: '0 10px',
            fontSize: 10.5,
            fontWeight: 600,
            borderRadius: 999,
            color: i === 0 ? 'var(--nb-bark-dark)' : 'var(--nb-subtle)',
            background: i === 0 ? 'var(--nb-bg)' : 'transparent',
          }}
        >
          {s}
        </span>
      ))}
    </div>
  );
}
